import {
  formatInstanceVersion,
  parseInstanceVersion,
} from "@stores/instances/utils";

export function getInstanceMetabaseMajorVersion(
  instanceVersion?: string | null,
): number | null {
  if (!instanceVersion) {
    return null;
  }

  try {
    const compactVersion = formatInstanceVersion(instanceVersion, true);
    return parseInstanceVersion(compactVersion)?.major ?? null;
  } catch {
    return null;
  }
}
